import { useQuery } from "@tanstack/react-query";
import type { Organization } from "@talenthop/shared";
import { api } from "../../lib/api.js";
import { useAuth } from "../../lib/AuthContext.js";

/**
 * The signed-in user's own organization (with its Wave-3 `kind`). Shares the react-query cache
 * key with UsersApp so this is a free read on any page inside the users persona.
 */
export function useMyOrg(): { org: Organization | undefined; isLoading: boolean } {
  const { me } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: ["my-org", me?.orgId],
    queryFn: () => api.get<{ orgs: Organization[] }>("/orgs"),
    enabled: !!me?.orgId,
  });
  const org = data?.orgs?.find((o) => o.id === me?.orgId) ?? data?.orgs?.[0];
  return { org, isLoading };
}
